module.exports = __webpack_public_path__ + "static/proje_975-120d2666bc9be9cadaddeb9e35aeb34d.jpg";